module.exports = __webpack_public_path__ + "img/icon-plus-circle.2e33df22.svg";